import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updateHeroSection, getHeroSectionById } from "adminApi/WebsiteSettingsApi/HeroSectionApi";
import { validateForm } from "utils/validation";
import { HeroSectionRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditHeroSectionForm from "./Componates/EditHeroSectionForm";
import fields from "../json/HeroSectionListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { setRefetchTrigger } from "Hooks/useRefetchOnReturn";
import { getImageUrl } from "utils/imageHelper";

const EditHeroSection = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Create navigation function with refetch trigger
  const navigateWithRefetch = setRefetchTrigger(navigate, 'heroSection');

  // Initialize default form values - use field.name consistently
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setValues, setErrors } = useFormChange(
    initialValues,
    HeroSectionRules
  );

  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    getHeroSectionById,
    setValues
  );

  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await updateHeroSection({ id, data: formData });
    },
    (vals) => {
      const valsToValidate = { ...vals };
      if (typeof valsToValidate.background_image === "string") {
        delete valsToValidate.background_image;
      }
      delete valsToValidate.background_imagePreview;

      const err = validateForm(valsToValidate, HeroSectionRules);
      setErrors(err);
      return err;
    },
    navigateWithRefetch,
    "Hero Section Updated successfully"
  );

  return (
    <>
      {(loading || loadingFetch) && <Spinner isSpinner={true} />}
      <EditHeroSectionForm
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={values.background_imagePreview || getImageUrl(values.background_image)}
        loading={loading}
      />
    </>
  );
};

export default EditHeroSection;
